export const ITEMS_REQUESTS_TYPES = {
    GET_ITEMS_REQUESTS: 'GET_ITEMS_REQUESTS',
    PATCH_MODIFY: 'PATCH_MODIFY',
    FILTER_LIST_REQUESTS: 'FILTER_LIST_REQUESTS',
    SET_CONFIG_FILTERED_ITEMS_REQUESTS: 'SET_CONFIG_FILTERED_ITEMS_REQUESTS',
    SET_CONFIG_PAGE_ITEMS_REQUESTS: 'SET_CONFIG_PAGE_ITEMS_REQUESTS',
    SET_CONFIG_PAGE_ITEMS_REQUESTS_COUNT: 'SET_CONFIG_PAGE_ITEMS_REQUESTS_COUNT',
    SET_CONFIG_SORTED_ITEMS_REQUESTS : 'SET_CONFIG_SORTED_ITEMS_REQUESTS',
    SAVE_PRICE : 'SAVE_PRICE',
}